import type { QuoteAcceptanceChannel } from '@chukua/common';

/** Display labels for `QUOTE_ACCEPTANCE_CHANNELS` — same idiom as `JOB_SOURCE_LABELS`. */
export const QUOTE_ACCEPTANCE_CHANNEL_LABELS: Record<QuoteAcceptanceChannel, string> = {
  phone: 'Phone',
  whatsapp: 'WhatsApp',
  email: 'Email',
  written: 'Written',
  in_person: 'In person',
};
